import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ModalsService } from '../../../../shared/services/utils/modals.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-panel-layout',
    templateUrl: './panel-layout.component.html',
})
export class PanelLayoutComponent implements OnInit, OnChanges, OnDestroy {
    destroyed = new Subject<void>();
    hidden = true;
    hide = false;
    @Input() panelId: string;
    @Input() classes: string;

    constructor(private ms: ModalsService) {}

    ngOnInit() {
        this.subscribePanelSubject();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.panelId && changes.panelId.currentValue) {
            this.panelId = changes.panelId.currentValue;
        }
    }

    subscribePanelSubject() {
        return this.ms
            .getPanelData()
            .pipe(takeUntil(this.destroyed))
            .subscribe((panelData) => {
                this.hidden = !panelData || panelData.modalId !== this.panelId;
            });
    }

    close() {
        this.hide = true;
        // cerramos el panel al acabar la animación
        setTimeout(() => {
            this.ms.closePanel();
        }, 300);
    }

    ngOnDestroy(): void {
        this.destroyed.next();
        this.destroyed.complete();
    }
}
